import React from "react";


export default function MemberCard({ member }: any) {
  let descLines;
  if (member.description) {
    descLines = member.description.split(',');
  }

  return (
  <div className={!member.advisor ? "col-xl-3 col-sm-6 mb-5" : "col-xl-4 col-sm-6 mb-5"} key={member.name}>
    <div className="cards bg-white rounded shadow-sm py-5 px-4 about-us-card">
      <img
        onClick={member.title == "Lead Developer" ? member.clickHandler : ()=>{}}
        src={member.image}
        alt=""
        width="100"
        className="img-fluid rounded-circle mb-3 img-thumbnail shadow-sm"
      ></img>
      <h5 className="mb-0">{member.name}</h5>
      <span className="small ">{member.title}</span>
      {
        descLines && 
          <span className="small text-muted">
            {
              descLines.map((line: string, i: number) => 
              <div key={i} className="member-desc-line">
                {line}
                {i !== descLines.length-1 && ","}
              </div>
            )}
          </span>
      }
      <ul className="social mb-0 list-inline mt-3">
      {
          member.website &&
          <li className="list-inline-item">
            <a
              className="btn-floating btn-lg btn-git"
              type="button"
              role="button"
              href={member.website}
              target="_blank"
            >
              <i className="fas fa-globe"></i>
            </a>
          </li>
        }
        {
          member.github &&
          <li className="list-inline-item">
            <a
              className="btn-floating btn-lg btn-git"
              type="button"
              role="button"
              href={member.github}
              target="_blank"
            >
              <i className="fab fa-github"></i>
            </a>
          </li>
        }
        {
          member.linkedin &&
          <li className="list-inline-item">
            <a
              className="btn-floating btn-lg btn-li"
              type="button"
              role="button"
              href={member.linkedin}
              target="_blank"
            >
              <i className="fab fa-linkedin-in"></i>
            </a>
          </li>
        }
      </ul>
    </div>
  </div>
  )
}